const content: { [key: string]: string } = {
  pageTitle: "Business Selector",
  pleaseSelect: "Please select a business",
};

export default content;
